module.exports = __webpack_public_path__ + "img/7.aa13c887.png";